import { CoreState } from '../types';

export const CORE_INITIAL_STATE: CoreState = {
  user: undefined,
};
